// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/product/Product"),
  orderPrio: 40,
  iconType: "file-ppt",
  name: "product",
  subApps: [
    {
      name: "attribute"
    },
    {
      name: "product"
    }
  ]
}: AppType)
